import moment from 'moment-timezone'
import type { GenericDate } from '@adc/sdk/types'
import * as blueprint from '@adc/blueprint'

export const getTimezoneAbbreviation = () => {
  const timezone = blueprint.utils.calculateTimeZone()
  return moment.tz(timezone).format('z')
}

const AUCTION_DURATION_START_DATE_TIME_FORMAT = 'MMM D, YYYY h:mm A'
const AUCTION_DURATION_END_DATE_FORMAT = 'MMM D, YYYY'

export function getAuctionDurationDisplayText(
  startDateTime: GenericDate | string = '',
  endDateTime: GenericDate | string = ''
): string {
  const timezone = blueprint.utils.calculateTimeZone()

  const startDateTimeText = moment
    .tz(startDateTime, timezone)
    .format(AUCTION_DURATION_START_DATE_TIME_FORMAT)

  const endDateTimeText = moment
    .tz(endDateTime, timezone)
    .format(AUCTION_DURATION_END_DATE_FORMAT)

  return `${startDateTimeText} - ${endDateTimeText}`
}
